import React from 'react';
import { graphql } from 'gatsby';

import Website from 'components/ui-setup';
import Layout from 'components/layout';
import InformationSecurity from 'components/information-security';

type Props = {
  data: Object,
};

const InformationSecurityPolicyPage = ({ data }: Props) => {
  const {
    informationSecurityJson,
    logoJson,
    socialMediaJson,
    siteJson,
    cookieConsentJson,
  } = data;

  return (
    <Website
      content={{
        ...informationSecurityJson,
        menu: siteJson?.content,
        cookieConsent: cookieConsentJson,
        logo: logoJson,
        socialMedia: socialMediaJson,
      }}>
      <Layout>
        <InformationSecurity />
      </Layout>
    </Website>
  );
};

export default InformationSecurityPolicyPage;

export const query = graphql`
  query InformationSecurityPageQuery {
    informationSecurityJson {
      hero {
        background {
          image {
            xl
            lg
            md
            sm
            xs
          }
        }
        title
      }
      informationSecurity {
        text
      }
      meta {
        description
        title
      }
    }
    siteJson {
      ...SiteJsonFragment
    }
    cookieConsentJson {
      ...CookieConsentJsonFragment
    }
    logoJson {
      ...LogoJsonFragment
    }
    socialMediaJson {
      ...SocialMediaJsonFragment
    }
  }
`;
